export const cx = (...args: String[]) => {
    return args.join(" ");
}